import Axios from "Services/Auth/AxiosInterceptors";

// from/to are YYYY-MM-DD (or omitted for "All time", which the backend still
// floors at the go-live date). Sent as local day boundaries so "Today" means
// the admin's today, matching the Conversions page.
const localDayStartISO = (ymd) => {
  if (!ymd) return undefined;
  const [y, m, d] = String(ymd).split("-").map(Number);
  return new Date(y, m - 1, d, 0, 0, 0, 0).toISOString();
};

const localDayEndISO = (ymd) => {
  if (!ymd) return undefined;
  const [y, m, d] = String(ymd).split("-").map(Number);
  return new Date(y, m - 1, d, 23, 59, 59, 999).toISOString();
};

export const AdminDashboard = async ({ from, to } = {}) => {
  const {
    data: { result },
  } = await Axios.get(`/admin/dashboard/get`, {
    params: {
      from: localDayStartISO(from),
      to: localDayEndISO(to),
    },
  });
  return result;
};
